export default __webpack_public_path__ + "img/8c24f9e7cba1e1cd6cff0c3e30a32ccd.png";